/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_ThemeInputs */



/**
* | output |
* | --- |
* | "Auto" |
*
* @param {Auto_ThemeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const auto_theme = /** @type {((inputs?: Auto_ThemeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_ThemeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Auto")
	if (locale === "de") return /** @type {LocalizedString} */ ("Auto")
	if (locale === "it") return /** @type {LocalizedString} */ ("Auto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Авто")
	if (locale === "es") return /** @type {LocalizedString} */ ("Auto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("汽车")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑटो")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Auto")
	return /** @type {LocalizedString} */ ("Auto")
});